import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaHidden", "ariaLabel", "children", "color", "fontSize", "loading", "variant"];
import React, { forwardRef } from 'react';
import { Box, Button, alpha, darken, useTheme } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useThemeColor } from '../../../themes/hooks/useThemeColor';
var EzButtonMui = forwardRef(function (_ref, ref) {
  var _theme$typography;
  var ariaHidden = _ref.ariaHidden,
    ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    color = _ref.color,
    fontSize = _ref.fontSize,
    loading = _ref.loading,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var isCommonColor = (color === null || color === void 0 ? void 0 : color.startsWith('common.')) || color === 'destructive';
  var themeColor = useThemeColor(color === 'destructive' ? 'common.red110' : color);
  var ButtonComponent = loading ? LoadingButton : Button;
  var baseVariant = function baseVariant(btnVariant) {
    switch (btnVariant) {
      case 'filled':
        return 'contained';
      case 'inline':
        return 'text';
      default:
        return btnVariant;
    }
  };
  return React.createElement(ButtonComponent, _extends({
    ref: ref,
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    classes: {
      root: "EzButton EzButton-".concat(variant),
      startIcon: 'EzButton-startIcon',
      endIcon: 'EzButton-endIcon',
      disabled: 'EzButton-disabled'
    },
    color: isCommonColor ? undefined : color,
    disableElevation: true,
    loading: loading ? true : undefined,
    sx: {
      bgcolor: isCommonColor && variant === 'filled' ? themeColor : undefined,
      borderColor: isCommonColor && variant === 'outlined' ? alpha(themeColor, 0.5) : undefined,
      color: isCommonColor && variant !== 'filled' ? themeColor : undefined,
      fontSize: fontSize === 'inherit' ? fontSize : ((_theme$typography = theme.typography) === null || _theme$typography === void 0 || (_theme$typography = _theme$typography.font) === null || _theme$typography === void 0 ? void 0 : _theme$typography.size[fontSize]) || undefined,
      padding: variant === 'inline' ? 0 : undefined,
      verticalAlign: variant === 'inline' ? 'inherit' : undefined,
      '&:hover, &:active': {
        bgcolor: variant === 'filled' ? darken(themeColor, 0.2) : alpha(themeColor, 0.1),
        borderColor: variant !== 'text' ? themeColor : undefined
      }
    },
    variant: baseVariant(variant)
  }, props), React.createElement(Box, {
    whiteSpace: "nowrap"
  }, children));
});
EzButtonMui.displayName = 'EzButtonMui';
export default EzButtonMui;